<template>
  <form
    @submit.prevent="validateLogin"
    id="form-login"
    role="form"
    autocomplete="off"
    class="assistance__login-panel"
  >
    <h2 class="assistance__login-title">Área Restrita</h2>

    <hr />

    <div class="form-group">
      <label for="email" class="login-painel__label">Email</label>

      <input
        type="email"
        name="email"
        v-model="email"
        v-validate="'required'"
        value
        class="form-control"
        autocapitalize="off"
        autocorrect="off"
        id="email"
      />

      <div class="vee-error" v-show="errors.has('email')">{{ errors.first('email') }}</div>
    </div>

    <div class="form-group">
      <label for="password" class="login-painel__label">Senha</label>

      <input
        type="password"
        name="password"
        v-model="password"
        v-validate="'required|min:5'"
        value
        class="form-control"
        autocapitalize="off"
        autocorrect="off"
        id="password"
      />

      <div class="vee-error" v-show="errors.has('password')">{{ errors.first('password') }}</div>
    </div>

    <div class="clearfix">
      <div v-show="errorMessage" class="alert alert-danger">{{errorMessage}}</div>

      <div class="form-group login-painel__container-submit">
        <input
          type="submit"
          :value="btnSubmitText"
          class="btn-action btn-action--center assistance__login-btn-submit"
          id="btn-submit-autentica"
        />
      </div>
    </div>

    <!-- cliente.password.showResetForm -->
    <div class="form-group text-center">
      <a
        href="/assistance/password/reset"
        class="login-painel__btn-esqueceu-senha"
      >Esqueceu sua senha?</a>
    </div>
  </form>
</template>

<script>
import api from "../support/api";

export default {
  data() {
    return {
      email: "",

      password: "",

      errorMessage: false,

      btnSubmitText: "Login"
    };
  },

  // created(){
  //   this.$validator.localize('en');
  //   this.$i18n.locale = 'en';
  // },

  methods: {
    validateLogin() {
      this.$validator.validateAll().then(result => {
        if (result) {
          api.sendAuthRequest(this);
          return;
        }
      });
    },

    changeBtnSubmitText(label) {
      if (label === "login") {
        this.btnSubmitText = "login";
      } else {
        this.btnSubmitText = "aguarde...";
      }
    }
  }
};
</script>
